// src/config.js
/**
 *  Devuelve la configuración de Auth0 tomada de variables de entorno.
 *  - REACT_APP_AUTH0_DOMAIN
 *  - REACT_APP_AUTH0_CLIENT_ID
 *  - REACT_APP_AUTH0_AUDIENCE  (opcional; puede quedar vacío)
 *
 *  Para ampliarlo, basta con agregar más variables y retornarlas aquí.
 */
export function getConfig() {
  const domain   = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audienceRaw =
    process.env.REACT_APP_AUTH0_AUDIENCE || "";

  // Si definiste {yourApiIdentifier} en Auth0 Quickstart, lo filtramos.
  const audience =
    audienceRaw && audienceRaw !== "{yourApiIdentifier}"
      ? audienceRaw
      : null;

  return {
    domain,
    clientId,
    ...(audience ? { audience } : null),
  };
}
